var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-date-picker" },
    [
      _c(
        "v-dialog",
        {
          attrs: { disabled: _vm.disabled, width: "290px", "full-width": "" },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "v-text-field",
            {
              attrs: {
                slot: "activator",
                value: _vm.dateDisplayText,
                label: _vm.label,
                placeholder: _vm.placeholder,
                clearable: _vm.clearable,
                "error-messages": _vm.$formErrors(_vm.v),
                disabled: _vm.disabled,
                readonly: "",
              },
              on: { input: _vm.clear },
              slot: "activator",
            },
            [
              _c(
                "span",
                {
                  class: {
                    "required-field": _vm.isRequired && !_vm.hideRequired,
                  },
                  attrs: { slot: "label" },
                  slot: "label",
                },
                [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c("v-date-picker", {
            attrs: {
              value: _vm.convertDateToISO(_vm.value),
              min: _vm.convertDateToISO(_vm.min),
              max: _vm.convertDateToISO(_vm.max),
              readonly: _vm.readonly,
              color: "secondary",
              locale: "pt-br",
              scrollable: "",
            },
            on: { change: _vm.change },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }